import React, { useContext, useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  TextField,
  InputAdornment,
  Grid,
  Divider,
  Button,
  FormControlLabel,
  FormLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@material-ui/core'
import { ReactComponent as AddSvg } from '../../assets/add.svg'
import {
  InsurancePurchaseContextStore,
  INSURANCE_CONTEXT_ACTIONS,
} from '../../context/InsuracePurchaseContext'
import { PolicyManagementContextStore } from '../../context/PolicyManagementContext'
import FlexView from 'react-flexview/lib'
import NewFillButton from '../Core/NewFillButton'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { Action } from '../../models/Action'
import { OptionalTag } from '../Core/OptionalTag'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { BrowserView } from 'react-device-detect'
import policymanagementApi from '../../api/policymanagement.api'
import { awaitWithLoading } from '../../services/utils'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import { COUNTRIES } from '../../Constants'
import LocalizationService from '../../services/LocalizationService'

export const OperatorAddForm = ({
  operators,
  onOpAdd,
  onFinish,
  onOpDelete,
  ...props
}) => {
  const { register, trigger, watch, setValue, errors, getValues, control } =
    useForm({ mode: 'onChange' })
  const [showForm, setShowForm] = useState(operators.length == 0)
  const [editMode, setEditMode] = useState(-1)

  const onSubmit = async () => {
    if (showForm) {
      let valid = await trigger()
      if (valid) {
        onOpAdd(getValues(), editMode)
        setShowForm(false)
        setEditMode(-1)
      }
    } else {
      onFinish()
    }
  }

  const addAnother = () => {
    setShowForm(true)
  }

  const onEdit = (index) => {
    setEditMode(index)
    setShowForm(true)
  }

  const onDelete = async (index) => {
    onOpDelete(index)
  }

  const isEditMode = () => {
    return editMode >= 0
  }

  const shrink = () => {
    return isEditMode() ? true : undefined
  }

  useEffect(() => {
    if (editMode >= 0 && showForm) {
      setValue('name', operators[editMode].name)
      setValue('training_status', operators[editMode].training_status)
      setValue('flight_hours', operators[editMode].flight_hours)
    }
  }, [editMode, showForm])

  return (
    <React.Fragment>
      <BrowserView>
        <div className="text-body blue textcenter bold margin-bottom-basic">
          Add Operator
        </div>
      </BrowserView>
      {operators.map((item, index) => (
        <React.Fragment key={index}>
          <FlexView className="margin-top-small full-width space-between">
            <FlexView column>
              <div className="text-body black">{item.name}</div>
            </FlexView>
            <FlexView vAlignContent={'center'}>
              <EditIcon
                className="tiny-icon clickable"
                color="primary"
                onClick={() => onEdit(index)}
              />
              <DeleteIcon
                className="tiny-icon margin-left-6 clickable"
                color="primary"
                onClick={() => onDelete(index)}
              />
            </FlexView>
          </FlexView>
          <Divider />
        </React.Fragment>
      ))}
      {showForm && (
        <>
          <FlexView column>
            <TextField
              fullWidth
              variant="outlined"
              label="Name"
              autoComplete="name"
              className="margin-top-small"
              name="name"
              inputRef={register({ required: true })}
              helperText={errors.name && errors.name.type + ' is required'}
              error={!!errors.name}
              InputLabelProps={{ shrink: shrink() }}
            />

            <Controller
              control={control}
              rules={{
                validate: (x) => !!x && x != 'none',
                required: true,
              }}
              defaultValue={'none'}
              name="training_status"
              as={
                <Select
                  error={!!errors.training}
                  variant="outlined"
                  className="margin-top-medium">
                  <MenuItem disabled value={'none'}>
                    <div className="placeholder-text">
                      CAA UAS training or national authority equivalent
                    </div>
                  </MenuItem>
                  <MenuItem value={'yes'}>Yes</MenuItem>
                  <MenuItem value={'no'}>No</MenuItem>
                  <MenuItem value={'inprogress'}>In Progress</MenuItem>
                </Select>
              }
            />
            <FormHelperText error={!!errors.training}>
              Select CAA UAS training or national authority equivalent
            </FormHelperText>

            <Controller
              control={control}
              rules={{
                validate: (x) => !!x && x != 'none',
                required: true,
              }}
              name="flight_hours"
              defaultValue="none"
              as={
                <Select
                  error={!!errors.flight_hours}
                  variant="outlined"
                  className="margin-top-small">
                  <MenuItem disabled value={'none'}>
                    <div className="placeholder-text">
                      UAS flight time hours
                    </div>
                  </MenuItem>
                  <MenuItem value={'0'}>{'<10 hours'}</MenuItem>
                  <MenuItem value={'10'}>{'>10 hours'}</MenuItem>
                </Select>
              }
            />
            <FormHelperText error={!!errors.flight_hours}>
              Select UAS flight time hours
            </FormHelperText>
          </FlexView>
          <Divider />
        </>
      )}
      <FlexView
        hAlignContent={!isEditMode() && !showForm ? undefined : 'center'}
        className="space-between full-width">
        {!isEditMode() && !showForm && (
          <FlexView vAlignContent={'center'}>
            <AddSvg onClick={addAnother} className="clickable blue-svg-path" />
            <Button
              onClick={addAnother}
              variant="text"
              color="primary"
              style={{ textTransform: 'none' }}>
              Add Another
            </Button>
          </FlexView>
        )}
        <NewFillButton onClick={onSubmit}>
          {showForm ? 'Save' : 'Finish'}
        </NewFillButton>
      </FlexView>
    </React.Fragment>
  )
}
